<template>
    <AppLayout page="/reports" pageTitle="Reports">
        <v-container class="pt-0" fluid>
            <v-row>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View admin reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/weekly-recap">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title
                                        >Weekly Studio Recap</v-card-title
                                    >
                                    <v-card-subtitle
                                        >Trailing week KPIs by
                                        location</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View financial reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/teacher-pay">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>Teacher Pay</v-card-title>
                                    <v-card-subtitle
                                        >Monthly pay due to
                                        teachers</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View financial reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/upcoming-invoices">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title
                                        >Upcoming Invoices</v-card-title
                                    >
                                    <v-card-subtitle
                                        >Preview customer
                                        charges</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View generic reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/past-due-invoices">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title
                                        >Past Due Invoices</v-card-title
                                    >
                                    <v-card-subtitle
                                        >Review unpaid charges</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View statistical reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/first-visits">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>First Visits</v-card-title>
                                    <v-card-subtitle
                                        >View student's first time visiting a
                                        class or private lesson series
                                        (Assessments...)
                                    </v-card-subtitle></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View statistical reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/enrollments">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>Enrollments</v-card-title>
                                    <v-card-subtitle
                                        >View memberships sold</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View statistical reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/drop-ins">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>Drop-Ins</v-card-title>
                                    <v-card-subtitle
                                        >View Drop-in passes
                                        sold</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View statistical reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/withdrawals">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>Withdrawals</v-card-title>
                                    <v-card-subtitle
                                        >View Membership
                                        cancellations</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View admin reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/gift-cards">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>Gift Cards</v-card-title>
                                    <v-card-subtitle
                                        >Review gift card
                                        purchases</v-card-subtitle
                                    ></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="4"
                    lg="3"
                    v-if="can('View financial reports')"
                >
                    <v-card class="soli-round">
                        <Link href="/reports/finance-entry">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>Finance Entry</v-card-title>
                                    <v-card-subtitle
                                        >Record Quickbooks monthly finances
                                    </v-card-subtitle></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </AppLayout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";

export default {
    props: [],
    components: {
        AppLayout,
        Link,
    },
};
</script>
